import { supabase } from '@/integrations/supabase/client';

const SENSITIVE_FIELDS = ['numero_hin', 'mmsi', 'immatriculation'] as const;

/**
 * Chiffre les champs sensibles d'un bateau via l'Edge Function
 */
export const encryptAndSaveSensitiveFields = async (
  boatId: string,
  fields: Partial<Record<typeof SENSITIVE_FIELDS[number], string | null>>
): Promise<{ success: boolean; error?: string }> => {
  try {
    const { data, error } = await supabase.functions.invoke('sensitive-data', {
      body: {
        action: 'encrypt_and_save',
        data: { boat_id: boatId, fields },
      },
    });

    if (error) return { success: false, error: error.message };
    return { success: true };
  } catch (err: any) {
    return { success: false, error: err.message };
  }
};

/**
 * Déchiffre les champs sensibles d'un bateau via l'Edge Function
 */
export const decryptSensitiveFields = async (
  boatId: string
): Promise<{ data?: Record<string, string | null>; error?: string }> => {
  try {
    const { data, error } = await supabase.functions.invoke('sensitive-data', {
      body: {
        action: 'decrypt',
        data: { boat_id: boatId },
      },
    });

    if (error) return { error: error.message };
    return { data: data?.data };
  } catch (err: any) {
    return { error: err.message };
  }
};

/**
 * Vérifie si une valeur est chiffrée
 */
export const isEncrypted = (value: string | null | undefined): boolean => {
  return !!value && value.startsWith('enc:');
};

/**
 * Extrait les champs sensibles d'un objet bateau pour les chiffrer séparément
 */
export const extractSensitiveFields = (
  boatData: Record<string, any>
): { sensitiveFields: Record<string, string | null>; otherFields: Record<string, any> } => {
  const sensitiveFields: Record<string, string | null> = {};
  const otherFields: Record<string, any> = {};

  for (const [key, value] of Object.entries(boatData)) {
    if ((SENSITIVE_FIELDS as readonly string[]).includes(key)) {
      sensitiveFields[key] = value;
    } else {
      otherFields[key] = value;
    }
  }

  return { sensitiveFields, otherFields };
};
